import desk1 from "./desk1.png";
import desk2 from "./desk2.png";
import desk3 from "./desk3.png";
import desk4 from "./desk4.png";
import desk5 from "./desk5.png";
import desk6 from "./desk6.png";
import tab1 from "./tab1.jpg";
import tab2 from "./tab2.jpg";
import tab3 from "./tab3.jpg";
import tab4 from "./tab4.png";
import tab5 from "./tab5.png";
import mob1 from "./mob1.png";
import mob2 from "./mob2.png";
import mob3 from "./mob3.png";
import mob4 from "./mob4.png";
import mob5 from "./mob5.png";
import mob6 from "./mob6.png";
import icon from "./icon.svg";
import caret_right from "./caret_right.svg";
import down_arrow_alt from "./down_arrow_alt.svg";
import search from './search.svg';
import filtersArrowUp from './filtersArrowUp.svg';
import filtersArrowDown from './filtersArrowDown.svg';


export default {
  desk1,
  desk2,
  desk3,
  desk4,
  desk5,
  desk6,
  mob1,
  mob2,
  mob3,
  mob4,
  mob5,
  mob6,
  tab1,
  tab2,
  tab3,
  tab4,
  tab5,
  icon,
  caret_right,
  down_arrow_alt,
  search,
  filtersArrowUp,
  filtersArrowDown,
};



// import desk1 from "./desk1.webp";
// import desk2 from "./desk2.webp";
// import desk3 from "./desk3.webp";
// import desk4 from "./desk4.webp";
// import desk5 from "./desk5.webp";
// import desk6 from "./desk6.webp";
// import tab1 from "./tab1.webp";
// import tab2 from "./tab2.webp";
// import tab3 from "./tab3.webp";
// import tab4 from "./tab4.webp";
// import tab5 from "./tab5.webp";
// import mob1 from "./mob1.webp";
// import mob2 from "./mob2.webp";
// import mob3 from "./mob3.webp";
// import mob4 from "./mob4.webp";
// import mob5 from "./mob5.webp";
// import mob6 from "./mob6.webp";
// import icon from "./icon.svg";

// export default {
//   desk1,
//   desk2,
//   desk3,
//   desk4,
//   desk5,
//   desk6,
//   mob1,
//   mob2,
//   mob3,
//   mob4,
//   mob5,
//   mob6,
//   tab1,
//   tab2,
//   tab3,
//   tab4,
//   tab5,
//   icon,
// };
